import { StyleSheet } from 'react-native';
import { LILAC_300, LILAC_500, tokens } from '@airtel/air-design-system';
export var getComparisonViewCardWidgetStyles = sectionCount => {
  var _tokens$spacing = tokens.spacing,
    SPACING_0 = _tokens$spacing.SPACING_0,
    SPACING_1 = _tokens$spacing.SPACING_1,
    SPACING_10 = _tokens$spacing.SPACING_10,
    SPACING_16 = _tokens$spacing.SPACING_16;
  return StyleSheet.create({
    compareWrapper: sectionCount > 1 ? {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start'
    } : {},
    sectionRightMargin: {
      marginRight: SPACING_10
    },
    collapsibleTitleLastItem: {
      borderBottomLeftRadius: SPACING_16,
      borderBottomRightRadius: SPACING_16,
      borderBottomWidth: SPACING_1
    },
    titleContainer: {
      flex: 1
    },
    collapsibleContainer: {
      paddingBottom: SPACING_16,
      borderWidth: SPACING_1,
      borderTopWidth: SPACING_0,
      borderBottomWidth: SPACING_0,
      borderColor: LILAC_500,
      backgroundColor: LILAC_300
    }
  });
};